import { PriorityType } from '@gv/triage-components';

import { PriorityTypeSort } from 'store/api/action-queue/types';

import * as Styles from './styles';

export enum DynamicPriorityType {
  Admin = 'Admin',
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
}

export const dynamicPriorities = [
  {
    label: 'Admin',
    value: 'Admin',
    icon: <Styles.DynamicDot type={PriorityType.Admin} />,
  },
  ...Object.values(DynamicPriorityType)
    .filter((type: DynamicPriorityType) => type !== DynamicPriorityType.Admin)
    .sort((typeA: DynamicPriorityType, typeB: DynamicPriorityType) => {
      const valueA =
        typeA === DynamicPriorityType.Admin ? 0 : PriorityTypeSort[typeA];
      const valueB =
        typeB === DynamicPriorityType.Admin ? 0 : PriorityTypeSort[typeB];
      return valueA < valueB ? 1 : -1;
    })
    .map((type: DynamicPriorityType) => ({
      value: type,
      label: type,
      icon: <Styles.DynamicDot type={type} />,
    })),
];
